import { VBadge } from 'vuetify/lib/components/VBadge';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBadge,{staticClass:"open-windows-badge",attrs:{"color":"red darken-2","content":_vm.getActiveWindowsCount,"value":_vm.getActiveWindowsCount > 0,"offset-x":_vm.offsetX,"offset-y":_vm.offsetY,"overlap":""}},[_vm._t("content",function(){return [_c('w-icon',{attrs:{"size":"24"}},[_vm._v(" $wHistory ")])]},{"icon":_vm.icon})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }